import { stringify } from 'query-string';
import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { Spinner } from '../../../components';
import { Role } from '../../../models';
import { GeneralLink } from '../../../models/Routes';
import { userSelectors } from '../../../redux';

interface Props {
  requiredRole: Role;
  children: ReactElement;
}

const RolesGuard: FC<Props> = ({ requiredRole, children }) => {
  const userInfo = useSelector(userSelectors.getUserInfo);

  if (!userInfo) {
    return (
      <div className='center-content'>
        <Spinner size='large' />
      </div>
    );
  }

  if (!userInfo.roles.includes(requiredRole)) {
    return (
      <Redirect
        to={
          GeneralLink.ERROR +
          '?' +
          stringify({
            message: 'errorNotCorrectRole',
          })
        }
      />
    );
  }

  return children;
};

export default RolesGuard;
